import { useEffect, useRef, useState } from "react";
import { Element } from "./style";

export const VericalScroller = ({ top, target, visible }) => {
  const [parentHeight, setParentHeight] = useState(0);
  const ref = useRef();
  useEffect(() => {
    setParentHeight(
      ref.current.parentElement.getBoundingClientRect().height - 120
    );
  }, []);
  const topAmount = parentHeight * (top / 100) + 10;
  const updateScroll = (e) => {
    for (const e of document.body.querySelectorAll("*")) {
      e.classList.add("prevent-select");
    }

    const totalScrollableAmount =
      target?.current?.scrollHeight - target?.current?.clientHeight;
    console.log(e.screenY - 130, e.screenY);
    const scrollAmount =
      ((e.screenY - 130 / 2) / (target.current.clientHeight + 130 / 2)) * 100;
    const scrollPosition = (totalScrollableAmount / 100) * scrollAmount;
    target.current.scrollTop = scrollPosition;
  };
  const onMouseDown = () => {
    document.addEventListener("mousemove", updateScroll);
    document.addEventListener("mouseup", () => {
      document.removeEventListener("mousemove", updateScroll);
      for (const e of document.body.querySelectorAll("*")) {
        e.classList.remove("prevent-select");
      }
    });
  };
  return (
    <Element
      ref={ref}
      onMouseDown={onMouseDown}
      style={{
        top: `${topAmount}px`,
        opacity: visible ? 1 : 0,
        animationName: visible ? "show" : "hide",
      }}
    />
  );
};
